import {create} from 'zustand';
import {Account, AccountSummaryResponse} from './types';
import {fetchSummary, loadAccount} from './ApiHelper';
import {getStorageItem, putStorageItem, StorageKeys} from './StorageHelper';

export interface AccountState {
  account: Account | null;
  loading: boolean;
  summary: AccountSummaryResponse | null;
  refresh: (force?: boolean) => void;
  fetchSummary: (force?: boolean) => void;
  setAccount: (accountId: string) => void;
  reset(): void;
  setDateRange: (daysSince: string, startDate?: Date, endDate?: Date) => void;
  dateRange: string;
}

const UseAccountStore = create<AccountState>((set) => {
  return {
    account: null,
    loading: true,
    summary: null,
    dateRange: getStorageItem(StorageKeys.UI_LEDGER_SINCE) ?? 'month',
    setDateRange: async (daysSince: string, startDate?: Date, endDate?: Date) => {
      putStorageItem(StorageKeys.UI_LEDGER_SINCE, daysSince);
      if(daysSince === "custom") {
        putStorageItem(StorageKeys.UI_LEDGER_START_DATE, startDate.toISOString());
        putStorageItem(StorageKeys.UI_LEDGER_END_DATE, endDate.toISOString());
      }
      set(() => ({dateRange: daysSince}));
    },
    setAccount: async (accountId: string) => {
      if (!accountId) {
        throw new Error('Account ID is required');
      }
      await putStorageItem(StorageKeys.ACTIVE_ACCOUNT_ID, accountId);
      UseAccountStore.getState().refresh();
    },
    refresh: async (force?: boolean) => {
      set(() => ({loading: true}));
      try {
        const account = await loadAccount(force);
        set(() => ({account, loading: false, hasErrors: false}));
      } catch (err: any) {
        set(() => ({hasErrors: true, loading: false, account: null}));
        throw err;
      }
    },
    fetchSummary: async (force?: boolean) => {
      try {
        const summary = await fetchSummary(force);
        set(() => ({summary}));
      } catch (err: any) {
        set(() => ({summary: null}));
        throw err;
      }
    },
    reset() {
      set(() => ({
        account: null,
        loading: false,
        summary: null,
      }));
    },
  };
});

export default UseAccountStore;
